<template>
  <div class="blog-page">
    <v-container class="blog-container">
      <!-- Header -->
      <div class="blog-header">
        <h1 class="blog-title">Blog</h1>
        <p class="blog-subtitle">
          Thoughts on tech, careers, and everything in between.
        </p>
      </div>

      <!-- Grid -->
      <v-row class="posts-grid">
        <v-col v-for="post in blogIndex" :key="post.id" cols="12" sm="6" lg="4">
          <v-card
            class="post-card"
            elevation="0"
            :to="{ name: 'BlogPageDetail', params: { id: post.id } }"
          >
            <div class="post-card-inner">
              <div class="post-meta">
                <span class="post-date">
                  <v-icon size="14" class="mr-1">mdi-calendar</v-icon>
                  {{ post.date }}
                </span>
              </div>
              <h2 class="post-title">{{ post.title }}</h2>
              <p class="post-excerpt">{{ post.excerpt }}</p>
              <div class="post-footer">
                <span class="read-more">
                  Read post <v-icon size="16">mdi-arrow-right</v-icon>
                </span>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { blogIndex } from "@/content/index.js";
export default {
  data() {
    return { blogIndex };
  },
};
</script>

<style scoped>
.blog-page {
  min-height: 100vh;
  background: linear-gradient(to bottom, #ffffff 0%, #f8f9fa 100%);
}

.blog-container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 3rem 1.5rem;
}

.blog-header {
  text-align: center;
  margin-bottom: 3rem;
}

.blog-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 0.5rem;
}

.blog-subtitle {
  font-size: 1.1rem;
  color: #666;
}

.posts-grid {
  gap: 0;
}

.post-card {
  height: 100%;
  border: 1.5px solid #e8eaf6;
  border-radius: 12px !important;
  background: #ffffff;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  cursor: pointer;
  text-decoration: none;
}

.post-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(0, 188, 212, 0.12) !important;
  border-color: #00bcd4;
}

.post-card-inner {
  padding: 1.75rem;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.post-meta {
  margin-bottom: 0.75rem;
}

.post-date {
  font-size: 0.8rem;
  color: #00bcd4;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: flex;
  align-items: center;
}

.post-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #1a1a2e;
  line-height: 1.4;
  margin-bottom: 0.75rem;
}

.post-excerpt {
  font-size: 0.9rem;
  color: #555;
  line-height: 1.6;
  flex-grow: 1;
  margin-bottom: 1.25rem;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.post-footer {
  margin-top: auto;
}

.read-more {
  font-size: 0.875rem;
  font-weight: 600;
  color: #00bcd4;
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>
